export var RelatedEntitiesResult = /*#__PURE__*/function (RelatedEntitiesResult) {
  RelatedEntitiesResult["KnowledgeDiscoveryRelatedEntityConnection"] = "KnowledgeDiscoveryRelatedEntityConnection";
  RelatedEntitiesResult["QueryError"] = "QueryError";
  return RelatedEntitiesResult;
}({});
export var RelatedEntityType = /*#__PURE__*/function (RelatedEntityType) {
  RelatedEntityType["KEY_PHRASE"] = "KEY_PHRASE";
  RelatedEntityType["TOPIC"] = "TOPIC";
  RelatedEntityType["USER"] = "USER";
  RelatedEntityType["CONFLUENCE_DOCUMENT"] = "CONFLUENCE_DOCUMENT";
  RelatedEntityType["CONFLUENCE_PAGE"] = "CONFLUENCE_PAGE";
  RelatedEntityType["CONFLUENCE_BLOGPOST"] = "CONFLUENCE_BLOGPOST";
  return RelatedEntityType;
}({});